<template>
    <div class="container">
        <h1>Static pages</h1>
        <div class="row justify-content-center">
            <div class="col">
                <PagesTable />
            </div>
        </div>
    </div>
</template>

<script>
import PagesTable from '@/components/pages/PagesTable.vue'
export default {
    name: 'EditPages',
    components: {
        PagesTable
    },
    data: () => {
        return {
        }
    },
    head: {
        title: 'Static Pages'
    },
    methods: {
    },
    async mounted() {
    }
}
</script>